import React, { FC } from "react";

import { Icon, IconType } from "~/components/atoms";

type RichHeaderProps = {
  title: string;
  description?: string | null;
  icon?: IconType;
  className?: string;
};

export const RichHeader: FC<RichHeaderProps> = ({
  title,
  description,
  icon = "ioDocumentTextOutline",
  className = "",
}) => {
  return (
    <div
      className={`bg-gradient-to-r from-primary-200 to-primary-300 rounded-xl p-6 border border-primary-400 ${className}`}
    >
      <h1 className="text-2xl font-bold text-secondary-900 flex items-center">
        <Icon
          icon={icon}
          size="2rem"
          color="text-primary-800"
          className="mr-3"
        />
        {title}
      </h1>
      {description && <p className="text-secondary-600 mt-2">{description}</p>}
    </div>
  );
};
